import { render, staticRenderFns } from "./bottomLeftChart.vue?vue&type=template&id=8c454d70&scoped=true"
import script from "./bottomLeftChart.vue?vue&type=script&lang=js"
export * from "./bottomLeftChart.vue?vue&type=script&lang=js"
import style0 from "./bottomLeftChart.vue?vue&type=style&index=0&id=8c454d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c454d70",
  null
  
)

export default component.exports